var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 16 16","width":"16","height":"16"}},[_c('rect',{attrs:{"width":"16","height":"16","fill":"#fff","rx":"8"}}),_c('path',{attrs:{"stroke":"#87A038","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.4","d":"M4.8 11.2l6.4-6.4M4.8 4.8l6.4 6.4"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }